<template>
    <div class="modal fade" id="modal_file" tabindex="-1" aria-labelledby="exampleModalFileLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div :class="`modal-content bg-${getColorMode.background} text-${getColorMode.text}`">
                <div :class="`modal-header bg-${getColorMode.FileBackground} text-${getColorMode.text} border-0 shadow-sm`">
                    <h5 class="modal-title" id="exampleModalfileLabel"> {{ modalTitle }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    {{ modalText }}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Cerrar</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Modal } from 'bootstrap'
export default {
    name: 'ModalFile',
    emits: ['closeModal'],
    props: {
        modalTitle: { type: String, default: '' },
        modalText: { type: String, default: '¿Estás seguro de realizar esta acción?' },
        modalType: { type: String, default: '' }
    },
    data() {
        return {
            modal: null,
        }
    },
    mounted() {
        this.modal = new Modal(document.getElementById('modal_file'), {})
        this.modal.show()
        let app = this
        document.getElementById('modal_file').addEventListener('hide.bs.modal', function () {
            app.$emit('closeModal')
        })
    },
    computed: {
        ...mapGetters('general', ['getColorMode']),
    }
}
</script>